module.exports = __webpack_public_path__ + "static/media/Spinner-2.2s-70px.9b5f16b4.gif";